import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/overview/health-dashboard')({
  beforeLoad: () => getTitleContextSlice('Health Dashboard'),
  staticData: {
    owner: CodeOwner.DataFabric,
  },
});
